import { Registerpage } from '../containers';

const Register = () => {
  return (
    <div>
        <div className="Register">
          <Registerpage />
        </div>
    </div>
  )
}

export default Register